module.exports = __webpack_public_path__ + "static/media/hrt.be6ddc46.svg";